import Utils from "./utils";
import Barba from 'barba.js';
import Verge from 'verge';

import ScrollTo  from './scrollTo';
/**
 * Gestion des changements de page smooth
 * Nous utilisons Barba.js pour faire ceci
 * http://Barbajs.org/
 */
class SmoothPagesTransition{

	/**
	 *
	 */
	constructor(Bulb){
		Utils.debug('💀SmoothPage : Construct');
		this.bulb = Bulb;
		this.linkClicked = false;
		this.lastScrollPosition = 0;
		history.scrollRestoration = 'manual';
	}

	/**
	 *
	 */
	init(){
		let self = this;

		//console.debug('Barba', Barba);

		this.scrollManager = new ScrollTo();

		this.changePreventCheck();

		Barba.Pjax.start();
		Barba.Pjax.getTransition = function() {
			return self.pageTransition();
		};

		Barba.Dispatcher.on('linkClicked', function(currentStatus) {
			self.linkClicked = true;
			self.lastScrollPosition = window.scrollY;
		});

		Barba.Dispatcher.on('initStateChange', function(currentStatus) {
			Utils.debug('💀loading new page');
		});

		Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {
			console.log('💀new page ready');
			let htmlObject = document.createElement('html');
			htmlObject.innerHTML = newPageRawHTML;
			self.newClassesToInject  = htmlObject.querySelector("body").className;
			self.elementorsCssToInject = $(htmlObject).find('#elementor-frontend-inline-css').html();
		});

		Barba.Dispatcher.on('transitionCompleted', function(currentStatus, prevStatus) {
			console.log('💀transitionCompleted');
			self.bulb.clear();
			self.scrollManager.reset();
			self.scrollManager.init();
			self.bulb.defaultEvents();

			if (!self.linkClicked) {
				console.log('state changed without a link being clicked... back button?', self.lastScrollPosition)
				window.scrollTo(0, self.lastScrollPosition);
				//document.querySelector('#app').scrollTop = self.lastScrollPosition;
			} else {

				console.log('state changed avec le  click sur un lien... on remonte la page')
				window.scrollTo(0, 0);
			}

			self.linkClicked = false


			self.bulb.closeLoader();

		});




	}


	changePreventCheck(){

		//console.debug('SmoothPageTransition : changePreventCheck');

		Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

		Barba.Pjax.preventCheck = function(evt, element) {

			if (!Barba.Pjax.originalPreventCheck(evt, element)) {
				return false;
			}

			// No need to check for element.href -
			// originalPreventCheck does this for us! (and more!)
			if (/.pdf/.test(element.href.toLowerCase())) {
				return false;
			}

			// on vire tous les liens de l'admin bar
			if($(element).parents('#wpadminbar').length){
				return false;
			}

			return true;
		};
	}

	/**
	 * Transition de disparition par defaut de Bulb
	 * Pas glop, mais c'est du vite fait bien fait
	 * @param elt
	 * @returns {Promise}
	 */
	pageDefaultCleanTransition(elt){
		return new Promise(function(resolve){
			resolve(true);
		})
	}


	/**
	 * Transition d'apparition par defaut de Bulb
	 * Pas glop, mais c'est du vite fait bien fait
	 * @param elt
	 * @param BarbaBaseTrantion
	 */
	pageDefaultAppearTransition(elt, BarbaBaseTrantion, bulb) {
		BarbaBaseTrantion.done();
		$(bulb.options.containerScrollable).trigger('SmoothPagesTransition:buildNextPage');
		/*
			gsap.set(
					$(elt),
					{
							visibility: 'visible',
							opacity: 1,
							y: Verge.viewportH()
					}
			);
			var t = new gsap.timeline(
					{
							paused: true,
							onComplete: function(){
									BarbaBaseTrantion.done();
									$(bulb.options.containerScrollable).trigger('SmoothPagesTransition:buildNextPage');
							}
					}
			);
			t.to($(elt), 1.5, {y: 0, ease: Expo.easeInOut})
			t.play();
		 */
	}


	/**
	 *
	 * @returns {*|Object}
	 */
	pageTransition(){
		var self = this;

		return Barba.BaseTransition.extend({


			start: function() {
				var _this = this;

				Utils.debug('💀page transition : start');
				self.bulb.menu.close();


				Promise
					.all([self.bulb.openLoader(), this.newContainerLoading, _this.clearCurrentPage()])
					.then( this.loadNextPageAssets.bind(this) );


			},


			/**
			 *
			 */
			clearCurrentPage: function(){
				let _this = this;
				let cleaningTransition = self.pageDefaultCleanTransition(_this.oldContainer);
				Utils.debug('💀pageTransition : clearCurrentPage');
				return cleaningTransition;
			},


			/**
			 *
			 */
			loadNextPageAssets: function(){
				Utils.debug('💀pageTransition : loadNextPageAssets    ');

				// on switch la classe du bosy
				$('body').removeClass().addClass(self.newClassesToInject);
				// on charge les styles iliens d'elementor
				$('#elementor-frontend-inline-css').html(self.elementorsCssToInject);

				let _this = this;
				let preloadAssetsPromise = self.bulb.preloadAssets();
				preloadAssetsPromise.then(function(){
					_this.buildNextPage();
				});

			},






			buildNextPage: function() {
				var _this = this;

				Utils.debug('💀pageTransition : buildNextPage');
				//window.scrollTo(0, 0);



				/*
				ga('send', {
						hitType: 'pageview',
						page: location.pathname
				});
				*/

				self.pageDefaultAppearTransition(this.newContainer, this, self.bulb);
			}
		});

	}



}

export default  SmoothPagesTransition;
